import { cartDetailsFragment } from '../queries/get-cart-query'

const cartLineItemUpdate = `
  mutation cartLinesUpdate(
    $cartId: ID!
    $lineItems: [CartLineUpdateInput!]!
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartLinesUpdate(cartId: $cartId, lines: $lineItems) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }

  ${cartDetailsFragment}
`

export default cartLineItemUpdate
